/**
 * layout — local presentation heuristic.
 *
 * The API deliberately dropped `displayType`; clients own presentation.
 * Layout is derived from the option `name` + the contents of its values.
 * Keep this the single source of the layout decision so it's easy to tune.
 *
 * Layouts map to `[data-layout]` in pf-picker-option.css:
 *   swatch | image-meta | x-split | y-split | text
 */

/**
 * @param {{ name?: string, values?: Array<object> }} option
 * @returns {'swatch'|'image-meta'|'x-split'|'y-split'|'text'}
 */
export function deriveLayout(option) {
  const name = (option?.name || '').toLowerCase();
  const values = option?.values || [];
  const hasSwatch = values.some((v) => v && v.swatchImageUrl);
  const hasDimensions = values.some((v) => v && v.dimensions);
  const hasMeta = values.some((v) => v && v.metaLabel);

  // Color / Ropehold axes with swatch imagery.
  if ((name.includes('color') || name.includes('ropehold')) && hasSwatch) {
    return name.includes('ropehold') ? 'image-meta' : 'swatch';
  }

  if (hasDimensions || hasMeta) return 'x-split';

  // Case Option / Case Pack / Pack.
  if (name.includes('case') || name.includes('pack')) return 'y-split';

  return 'text';
}
